export const emailRegexp =
  /^\w+([.-]?\w+)*(?:\+\d+)?@\w+([.-]?\w+)*(\.\w{2,3})+$/;
